export default "__VITE_ASSET__BcxCd0hU__"